import { Routes } from '@/src/common/enums/routes'
import { router } from 'expo-router'
import { z } from 'zod/v4'

const routes = Object.values(Routes)
const routesAvailableForDeepLinking = routes.filter((route) => route.availableForDeepLinking)

const getPathRouteMatcher = (path: string) => {
  const [pathWithoutParams, params] = path.split('?')
  return {
    path,
    params,
    pathMatchesRoute: (route: (typeof routes)[number]) =>
      pathWithoutParams === route.route ||
      ('aliases' in route && route.aliases.some((alias) => pathWithoutParams === alias)),
  }
}

const DeepLinkPath = z
  .string({ message: 'Braze Content Card navigation URL is not a string' })
  .startsWith('/', { message: 'Braze Content Card navigation URL must start with a slash' })
  .transform(getPathRouteMatcher)
  .transform(({ path, params, pathMatchesRoute }) => ({
    path,
    params,
    route: routesAvailableForDeepLinking.find(pathMatchesRoute)?.route,
  }))

function isRootPath(pathname: string) {
  return pathname === '/' || pathname === ''
}

export function navigateToAppUrl({
  navigationUrl,
  onError,
}: {
  navigationUrl: string
  onError: (error: unknown) => void
}) {
  const { data: linkPath, error } = DeepLinkPath.safeParse(navigationUrl)

  if (error || !linkPath.route) {
    onError(
      new Error('Invalid navigation URL when attempting to navigate from a Braze Content Card', {
        cause: {
          navigationUrl,
          zodError: error,
        },
      }),
    )
    return
  }

  router.replace(Routes.Home.route)

  if (!isRootPath(linkPath.route)) {
    // @ts-expect-error Due to zod validation confirming this
    // is available for deep linking and routes
    router.push(linkPath.path)
  }
}
